// extracted by mini-css-extract-plugin
module.exports = {"container":"SvenskUll_container__3Lj-c","title":"SvenskUll_title__11hUW","sub":"SvenskUll_sub__3_qeP"};